import { res } from './res';

export const labelsEN = new Map<number, string>([
    [res.Update, 'Update'],
    [res.SelectOrganization, 'Select an organization'],
    [res.Loading, 'Loading'],
    [res.LoadingInfo, 'Loading Information'],
    [res.LoadingUserData, 'Loading User Data Information'],
    [res.TitleDashboard, 'KPI OPERATIONAL STANDARD'],
    [res.ActivityNotCreated, 'Activity not created'],
    [res.TitleClosing, 'Closing'],
    [res.TitleOpening, 'Opening'],
    [res.TitleCoordinator, 'Coordinator'],
    [res.CompletedDashboard, 'Completed'],
    [res.StoresOf, 'Stores of'],
    [res.Stores, 'Stores'],
    [res.InventoryManagement, 'INVENTORY MANAGEMENT'],
    [res.MerchandiseEntry, 'Merchandise Entry'],
    [res.Reception, 'Reception'],
    [res.Income, 'Income'],
    [res.CorporateTransfer, 'Corporate Transfer'],
    [res.Return, 'Return'],
    [res.Units, 'Units'],
    [res.Inventories, 'Inventories'],
    [res.Differences, 'Differences'],
    [res.Pcs, 'Pcs'],
    [res.Cost, 'Cost'],
    [res.Execution, 'EXECUTION'],
    [res.ChangeMarketingCampaign, 'Change Marketing Campaign'],
    [res.ChangeMarketingCampaignUSA, 'USA Change Marketing Campaign'],
    [res.UpdatePrices, 'Update Prices'],
    [res.StoreType, 'Store Type'],
    [res.StoreLocation, 'Store Location'],
    [res.Department, 'Department'],
    [res.DetailType, 'Detail Type'],
    [res.SelectItem, 'Select an item'],
    [res.Campaign, 'Campaign'],
    [res.SupervisorZones, 'Supervisor Zones'],
    [res.BrandDepartment, 'Brand Department'],
    [res.BrandGender, 'Brand Gender'],
    [res.CompletedComply, 'COMPLETED'],
    [res.NotCompletedComply, 'NOT COMPLETED'],
    [res.VisualExecutiveZones, 'Visual Executive Zones'],
    [res.VisualZones, 'Visual Zones'],
    [res.AuditorZones, 'Auditor Zones'],
    [res.TotalRating, 'Total Rating'],
    [res.StoresVisited, 'Stores Visited'],
    [res.ByCategory, 'BY CATEGORY'],
    [res.ByRegion, 'BY REGION'],
    [res.Zones, 'ZONES'],
    [res.StoresMayus, 'STORES'],
    [res.Name, 'Name'],
    [res.TransferredPieces, 'Transferred Pieces'],
    [res.Compliance, 'Compliance'],
    [res.SupervisorName, 'Supervisor Name'],
    [res.TransferredPiecesAbbr, 'Transferred Pcs'],
    [res.CompositionTransfersMade, 'Composition of transfers made'],
    [res.Corporate, 'Corporate'],
    [res.BetweenStores, 'Between Stores'],
    [res.StoreName, 'Store Name'],
    [res.TopStoresGreaterPiecesTransferred, 'Top Stores with greater number of pieces transferred'],
    [res.ReturnedPieces, 'Returned Pieces'],
    [res.ComplianceApprovedReturns, 'Compliance Approved Returns'],
    [res.ReturnedPiecesAbbr, 'Return Pcs'],
    [res.CompositionReturnsMade, 'Composition of returns made'],
    [res.TopStoresGreaterPiecesWithReturn, 'Top Stores with greater number of pieces return'],
    [res.HistoricalChecklist, 'HISTORICAL CHECKLIST'],
    [res.CurrentMonth, 'Current month'],
    [res.AnnualAccumulated, 'Annual Accumulated'],
    [res.Day, 'Day'],
    [res.Month, 'Month'],
    [res.MinComplianceAccepted, 'MIN COMPLIANCE ACCEPTED'],
    [res.MadeInventories, 'Made inventories'],
    [res.UnitDifferences, 'Unit differences'],
    [res.CostDifferences, 'Cost differences'],
    [res.UnitsAbbr, 'Units'],
    [res.TransfersBetweenStores, 'Transfers Between Stores'],
    [res.Returns, 'Returns'],
    [res.DifferencesByInventory, 'Differences by inventory type'],
    [res.InventoryBySupervisor, 'Inventory by supervisor'],
    [res.TopStoresGreaterNumberDifferences, 'Top stores with greater number of differences'],
    [res.TotalNumberInventoriesMonth, 'Total number of inventories per month'],
    [res.InventoryType, 'Inventory type'],
    [res.Pieces, 'Pieces'],
    [res.NumberDifferences, 'Number of differences'],
    [res.ActivitiesReport, 'Activities Report'],
    [res.Download, 'Download'],
    [res.Download, 'Instructions'],
    [res.ActivityType, 'Activity Type'],
    [res.SelectAnOption, 'Select an option'],
    [res.NoAssignment, 'No assignment'],
    [res.Search, 'Search'],
    [res.Reference, 'Reference'],
    [res.ReferenceRequest, 'Reference'],
    [res.ActivityName, 'Activity Name'],
    [res.StartDate, 'Start Date'],
    [res.EndDate, 'End Date'],
    [res.Progress, 'Progress'],
    [res.Status, 'Status'],
    [res.ThereIsNoInformation, 'There is no information'],
    [res.Store, 'Store'],
    [res.ExecutionDate, 'Execution Date'],
    [res.Brand, 'Brand'],
    [res.NewActions, 'New Actions'],
    [res.Section, 'Section'],
    [res.Gender, 'Gender'],
    [res.StyleVariety, 'Style Variety'],
    [res.Description, 'Description'],
    [res.Price, 'Price'],
    [res.CompletedDate, 'Completed Date'],
    [res.AlertSelectActivityFirst, 'You must select an activity type first.'],
    [res.LevelOneTab, 'Level 1 (Tab)'],
    [res.LevelTwoCard, 'Level 2 (Card)'],
    [res.LevelThreeTitle, 'Level 3 (Title)'],
    [res.Instruction, 'Instruction'],
    [res.Answer, 'Answer'],
    [res.Comments, 'Comments'],
    [res.Photos, 'Photos'],
    [res.Generating, 'Generating'],
    [res.AlertOperationCouldNotBeCompleted, 'The operation could not be completed'],
    [res.GettingImages, 'Getting images'],
    [res.FailedToGetImages, 'Failed to get images'],
    [res.Duration, 'Duration'],
    [res.Action, 'Action'],
    [res.CommitmentDate, 'Commitment date'],
    [res.GoBack, 'Go Back'],
    [res.ActivityScheduler, 'Activity Scheduler'],
    [res.Consult, 'Consult'],
    [res.Edit, 'Edit'],
    [res.Program, 'Program'],
    [res.Activity, 'Activity'],
    [res.Instructions, 'Instructions'],
    [res.Periodicity, 'Periodicity'],
    [res.GettingChecklistList, 'Getting checklist list'],
    [res.AlertSelectRecordPerformSelectedAction, 'Select a record to perform the selected action'],
    [res.AlertUploadedFile, 'Uploaded file'],
    [res.AlertNoUploadedFileFound, 'No uploaded file found'],
    [res.AlertSelectOnlyOneFile, 'Select only one file'],
    [res.AlertOnlyPDFfilesAreAccepted, 'Only .PDF files are accepted, select another file'],
    [res.AlertFileSizeExceedsAllowedWeight, 'File size exceeds allowed weight'],
    [res.File, 'File'],
    [res.UploadedCorrectly, 'uploaded correctly'],
    [res.AlertOnlyXlsxfilesAreAccepted, 'Only .xlsx and .xls files are accepted, select another file'],
    [res.Row, 'Row'],
    [res.EnterLevelName, 'Enter level name'],
    [res.MinimumNumberPhotosMaximumNumberPhotos, 'Minimum number of photos cannot be greater than the maximum number of photos'],
    [res.MinimumNumberPhotosCannotBeLesThan0, 'Minimum number of photos cannot be less than 0'],
    [res.AlertSelectChecklistFunctionality, 'Select a checklist functionality'],
    [res.AlertEnterTheTitleOfTheChecklist, 'Enter the title of the Checklist'],
    [res.AlertSelectCampaignFromChecklist, 'Select campaign from checklist'],
    [res.AlertSelectOrganizationFromChecklist, 'Select organization from checklist'],
    [res.AlertSelectPeriodicityOfTheChecklist, 'Select periodicity of the checklist'],
    [res.AlertSelectOneStoreForTheChecklist, 'Select at least one store for the checklist'],
    [res.AlertSelectIfYouRequireNotice, 'Select if you require notice'],
    [res.AlertSelectNoticeDate, 'Select notice date'],
    [res.AlertSelectNoticeDocument, 'Select a notice document'],
    [res.AlertUploadFileWithNecessaryInstructions, 'Upload the file with the necessary instructions for the activity'],
    [res.AlertCouldNotSaveChecklist, 'Could not save checklist'],
    [res.AlertCouldNotEditChecklist, 'Could not edit checklist'],
    [res.AlertEnterCampaignName, 'Enter campaign name'],
    [res.AlertSelectStartDateDeadline, 'Select start date and deadline'],
    [res.AlertCampaignCreatedSuccessfully, 'Campaign created successfully'],
    [res.AlertSelectCampaignToEdit, 'Select campaign to edit'],
    [res.AlertSelectOrganization, 'Select organization'],
    [res.AlertCampaignSuccessfullyEdited, 'Campaign successfully edited'],
    [res.Save, 'Save'],
    [res.MandatoryInformation, 'Mandatory information'],
    [res.GeneralData, 'General data'],
    [res.ChecklistFunctionality, 'Checklist functionality'],
    [res.AssignedStores, 'Assigned stores'],
    [res.SeeStores, 'See stores'],
    [res.Title, 'Title'],
    [res.EnterTitle, 'Enter title'],
    [res.AddCampaign, 'Add Campaign'],
    [res.EditCampaign, 'Edit Campaign'],
    [res.Notice, 'Notice'],
    [res.RequiresNotice, 'Requires notice'],
    [res.NoticeDate, 'Notice date'],
    [res.NoticeAttachedDocument, 'Notice attached document'],
    [res.SelectAFile, 'Select a file'],
    [res.Choose, 'Choose'],
    [res.RequiresReadingNotice, 'Requires reading notice before executing'],
    [res.ActivityScheduling, 'Activity scheduling'],
    [res.Repeat, 'Repeat'],
    [res.Monday, 'Monday'],
    [res.MondayAbbr, 'M'],
    [res.Tuesday, 'Tuesday'],
    [res.TuesdayAbbr, 'T'],
    [res.Wednesday, 'Wednesday'],
    [res.WednesdayAbbr, 'W'],
    [res.Thursday, 'Thursday'],
    [res.ThursdayAbbr, 'T'],
    [res.Friday, 'Friday'],
    [res.FridayAbbr, 'F'],
    [res.Saturday, 'Saturday'],
    [res.SaturdayAbbr, 'S'],
    [res.Sunday, 'Sunday'],
    [res.SundayAbbr, 'S'],
    [res.LayoutDownload, 'Layout Download'],
    [res.UploadInstructionsFile, 'Upload instructions file'],
    [res.Detail, 'Detail'],
    [res.MinimumImages, 'Minimum Images'],
    [res.MaximumImages, 'Maximum Images'],
    [res.Answers, 'Answers'],
    [res.SelectStores, 'Select stores'],
    [res.Filters, 'Filters'],
    [res.OpeningHours, 'Opening Hours'],
    [res.ClosingHours, 'Closing Hours'],
    [res.AllMayusA, 'ALL'],
    [res.AllMayusO, 'ALL'],
    [res.CheckUnchekAll, 'Check/Uncheck all'],
    [res.Accept, 'Accept'],
    [res.Deadline, 'Deadline'],
    [res.Cancel, 'Cancel'],
    [res.ValidityOfTheChecklist, 'Validity of the checklist'],
    [res.RestrictChecklistHours, 'Restrict checklist hours'],
    [res.RequiresMaxExecutionTime, 'Requires maximum execution time'],
    [res.MaximumTimeRequired, 'Maximum time required'],
    [res.LevelOne, 'Level 1'],
    [res.CaptureMayus, 'CAPTURE'],
    [res.Score, 'Score'],
    [res.Message, 'Message'],
    [res.TemplateManager, 'Template Manager'],
    [res.Template, 'Template'],
    [res.DownloadTemplate, 'Download Template'],
    [res.Weighing, 'Weighing'],
    [res.Actions, 'Actions'],
    [res.RequiresTicket, 'Requires Ticket'],
    [res.CorrectiveActionsPerStore, 'Corrective actions per store'],
    [res.End, 'End'],
    [res.ChecklistType, 'Checklist type'],
    [res.Pending, 'Pending'],
    [res.Closed, 'Closed'],
    [res.NotPerformed, 'Not Performed'],
    [res.LastQualification, 'Last Qualification'],
    [res.Evaluator, 'Evaluator'],
    [res.LastEvaluation, 'Last Evaluation'],
    [res.YouMustConsultInforFirst, 'You must consult information first'],
    [res.CorrectiveActionsDetail, 'Corrective Actions Detail'],
    [res.Responsable, 'Responsable'],
    [res.RequiredDate, 'Required Date'],
    [res.SolutionDate, 'Solution Date'],
    [res.CorrectiveAction, 'Corrective Action'],
    [res.Close, 'Close'],
    [res.View, 'View'],
    [res.StoresReport, 'Stores Report'],
    [res.StoresReportChecklist, 'Store Visual Report'],
    [res.CumulativeTotal, 'Stores Report'],
    [res.StoreOpeningChecklist, 'Opening Checklist'],
    [res.StoreClosingChecklist, 'Store Closing Checklist'],
    [res.StoreOpeningChecklistUSA, 'USA Opening Checklist'],
    [res.StoreClosingChecklistUSA, 'USA Store Closing Checklist'],
    [res.SupervisorChecklist, 'Supervisor Checklist'],
    [res.SupervisorChecklistUSA, 'Supervisor Checklist USA'],
    [res.VIMChecklist, 'VIM Checklist'],
    [res.CorrectiveActions, 'Corrective Actions'],
    [res.AlertNoInfoToDownload, 'No information to download'],
    [res.AlertTheStartDateCannotBeHigher, 'The start date cannot be higher than the end date'],
    [res.CompliancePercentage, 'Compliance percentage'],
    [res.CompositionPercentage, 'Composition percentage'],
    [res.PercentageSent, 'Percentage Sent'],
    [res.PercentageReceived, 'Percentage Received'],
    [res.AlertCannotGenerateReport, 'Cannot generate report'],
    [res.VisualMerchandiserChecklist, 'Visual Merchandiser Checklist'],
    [res.VisualMerchandiserChecklistUSA, 'Visual Merchandiser Checklist USA'],
    [res.AuditorChecklist, 'Auditor Checklist'],
    [res.AuditorChecklistUSA, 'Auditor Checklist USA'],
    [res.CoordinatorChecklist, 'Coordinator Checklist'],
    [res.CoordinatorChecklistUSA, 'Coordinator Checklist USA'],
    [res.ReturnToProvider, 'Return to Provider'],
    [res.PhysicalInventory, 'Physical Inventory'],
    [res.ScheduleActivities, 'Schedule Activities'],
    [res.Receptions, 'Receptions'],
    [res.Incomes, 'Income'],
    [res.StoreTransfers, 'Store Transfers'],
    [res.ReturnsRequests, 'Returns Requests'],
    [res.ManageStores, 'Manage Stores'],
    [res.ManageDevicesAbbr, 'Manage Devices'],
    [res.OrganizationalStructure, 'Manage Stores per User'],
    [res.ManageEmployeesAbbr, 'Manage Employees'],
    [res.ManageZonesAbbr, 'Manage Zones'],
    [res.Indicators, 'Indicators'],
    [res.Operation, 'Operation'],
    [res.Inventory, 'Inventory'],
    [res.Configuration, 'Configuration'],
    [res.LogOut, 'Log Out'],
    [res.CEDISMerchandiseEntry, 'CEDIS Merchandise Entry'],
    [res.ASNMerchandiseEntry, 'ASN Merchandise Entry'],
    [res.SelectStore, 'Select Store'],
    [res.Delivery, 'Delivery'],
    [res.SendDate, 'Send Date'],
    [res.Received, 'Received'],
    [res.Entry, 'Entry'],
    [res.MerchandiseDetail, 'Merchandise detail'],
    [res.ShippingNumberDetail, 'Shipping number detail'],
    [res.FinishedA, 'Finished'],
    [res.Process, 'Process'],
    [res.AlertNoDeliveryInfoWasObtained, 'No delivery information was obtained'],
    [res.TransportStartDateMayus, 'TRANSPORT START DATE'],
    [res.ShippingNumberIncludedMayus, 'SHIPPING NUMBER INCLUDED'],
    [res.ShippingNumberReceivedMayus, 'SHIPPING NUMBER RECEIVED'],
    [res.ShippingNumberReceivedByASNMayus, 'SHIPPING NUMBER BY ASN'],
    [res.ShippingNumberReceivedWithoutASNMayus, 'SHIPPING NUMBER WITHOUT ASN'],
    [res.ShippingNumber, 'Shipping Number'],
    [res.Date, 'Date'],
    [res.Hour, 'Hour'],
    [res.ReceivedBy, 'Received By'],
    [res.ReferenceReception, 'Reference Reception'],
    [res.CancelShippingNumber, 'Cancel shipping number'],
    [res.YouReallyWantCancelShippingNumber, 'You really want to cancel this shipping number?'],
    [res.Yes, 'Yes'],
    [res.Not, 'No'],
    [res.ShippingNumberReceived, 'Shipping number received'],
    [res.ShippingNumberReceivedByASN, 'Shipping number by ASN'],
    [res.ShippingNumberReceivedWithoutASN, 'Shipping number without ASN'],
    [res.ViewComments, 'View comments'],
    [res.ViewPhotos, 'View photos'],
    [res.AlertErrorGettingInformation, 'View photos'],
    [res.MerchandiseTotalToEntryMayus, 'MERCHANDISE TOTAL SENT'],
    [res.MerchandiseEntryMayus, 'MERCHANDISE TOTAL RECEIVED'],
    [res.MissingMerchandiseMayus, 'TOTAL DIFFERENCES'],
    [res.Style, 'Style'],
    [res.Variety, 'Variety'],
    [res.Size, 'Size'],
    [res.EntryBy, 'Entry by'],
    [res.EntryDate, 'Entry date'],
    [res.EntryReference, 'Entry reference'],
    [res.AlertErrorGettingCatalogs, 'Error getting catalogs'],
    [res.ReceptionReport, 'ReceptionReport'],
    [res.Employee, 'Employee'],
    [res.Confirmation, 'Confirmation'],
    [res.CreateInventory, 'Create Inventory'],
    [res.CreatedBy, 'Created by'],
    [res.InventoryReference, 'Inventory reference'],
    [res.Counting, 'Counting'],
    [res.StockTPV, 'Stock TPV'],
    [res.Tags, 'Tags'],
    [res.Unsubscribe, 'Unsubscribe'],
    [res.Export, 'Export'],
    [res.AlertStoresCouldNotBeObtained, 'Stores could not be obtained'],
    [res.AlertOrganizationsCouldNotBeObtained, 'Organizations could not be obtained'],
    [res.AlertInventoriesCouldNotBeObtained, 'Inventories could not be obtained'],
    [res.AlertTitlesCouldNotBeObtained, 'Titles could not be obtained'],
    [res.AlertYouDoNotHaveThePermissionsToCreate, 'You do not have the permission to create'],
    [res.AlertYouDoNotHaveThePermissionsToEdit, 'You do not have the permission to edit'],
    [res.AlertYouDoNotHaveThePermissionsToRemoveInventory, 'You do not have the permissions to remove the inventory'],
    [res.AlertThisInventoryDoesNotHaveCapturedData, 'This inventory does not have captured data'],
    [res.AlertThereWasErrorConsultingDetailInventory, 'There was an error when consulting the detail of this inventory'],
    [res.AlertInventoryDataCouldNotBeObtained, 'Inventory data could not be obtained'],
    [res.AlertCantDeleteInventory, 'Can not delete inventory'],
    [res.Delete, 'Delete'],
    [res.Product, 'Product'],
    [res.CountingQuantity, 'Counting quantity'],
    [res.User, 'User'],
    [res.Profile, 'Profile'],
    [res.Scanned, 'Scanned'],
    [res.AlertTheDataHasBeenUpdatedSuccessfully, 'The data has been updated successfully'],
    [res.AlertInfoMustBeLoadedToGenerateTheFile, 'Information must be loaded into the table in order to generate the file'],
    [res.Quantity, 'Quantity'],
    [res.EditInventory, 'Edit inventory'],
    [res.SAPpiecesQuantity, 'SAP pieces quantity'],
    [res.CreateFilter, 'Create filter'],
    [res.CreateTags, 'Create tags'],
    [res.AddAtag, 'Add a tag'],
    [res.AddTags, 'Add tags'],
    [res.ReferenceTag, 'Reference tag'],
    [res.TagName, 'Tag name'],
    [res.PrintTag, 'Print tag'],
    [res.PrintAllTags, 'Print all tags'],
    [res.EnterNumberPieces, 'Enter # pieces'],
    [res.TagReference, 'Tag reference'],
    [res.AlertInventoryTypesCouldNotBeObtained, 'Inventory types could not be obtained'],
    [res.AlertBrandsCouldNotBeObtained, 'Brands could not be obtained'],
    [res.GettingTheStores, 'Getting the stores'],
    [res.GettingOrganizations, 'Getting organizations'],
    [res.ObtainingTheTypesOfInventories, 'Obtaining the types of inventories'],
    [res.ObtainingTheBrands, 'Obtaining the brands'],
    [res.GettingDepartments, 'Getting departments'],
    [res.AlertDepartmentsCouldNotBeObtained, 'Departments could not be obtained'],
    [res.GettingGenders, 'Getting genders'],
    [res.AlertGendersCouldNotBeObtained, 'Genders could not be obtained'],
    [res.AlertFilterCombinationCannotBeRepeated, 'Filter combination cannot be repeated'],
    [res.AlertYouMustSelectTheBrand, 'You must select the brand'],
    [res.AlertYouMustSelectTheDepartment, 'You must select the department'],
    [res.AlertYouMustSelectTheGender, 'You must select the gender'],
    [res.AlertYouMustSelectTheTypeInventory, 'You must select the type of inventory'],
    [res.AlertYouMustSelectTheStore, 'You must select the store'],
    [res.AlertNumberTagsMustBegreater, 'The number of tags must be greater than 0'],
    [res.AlertYouMustGenerateTheTags, 'You must generate the tags'],
    [res.AlertYouMustGenerateAtLeastOneFilter, 'You must generate at least one filter'],
    [res.GeneratingFilter, 'Generating filter'],
    [res.GeneratingTags, 'Generating tags'],
    [res.Tag, 'Tag'],
    [res.AlertCouldNotGetTheNextInventoryNumber, 'Could not get the next inventory number for the store'],
    [res.AlertYouMustHaveAtLeastOneTag, 'You must have at least one tag'],
    [res.GeneratingInventory, 'Generating inventory'],
    [res.AlertUnableSaveInventoryForTheStore, 'Unable to save inventory for the store'],
    [res.AlertYouDoNotHavePermissionsToPerformThisAction, 'You do not have permissions to perform this action'],
    [res.Validation, 'Validation'],
    [res.Scanning, 'Scanning'],
    [res.AlertYouMustCreateTheTagsBeforePrintingThem, 'You must create the tags before printing them'],
    [res.AddingTag, 'Adding tag'],
    [res.AlertTheTagCouldNotBeAdded, 'The tag could not be added'],
    [res.RemovingTag, 'Removing tag'],
    [res.TagCouldNotBeDeleted, 'Tag could not be deleted'],
    [res.generatePDF, 'Generate PDF'],
    [res.errorMessageGeneratePDF, 'There was an error connecting to the printer, contact technical support. Do you want to generate the PDF to print manually?'],

    [res.SupplierReturnsRequests, 'Supplier Returns Requests'],
    [res.OriginStore, 'Origin store'],
    [res.RequestReference, 'Request Reference'],
    [res.Reason, 'Reason'],
    [res.RequestedQuantity, 'Requested Quantity'],
    [res.Shipment, 'Shipment'],
    [res.Society, 'Society'],
    [res.Invoice, 'Invoice'],
    [res.RequestDate, 'Request Date'],
    [res.ApprovalDate, 'Approval Date'],
    [res.LastShipmentDate, 'Last Shipment Date'],
    [res.GettingReturnsRequests, 'Getting returns requests'],
    [res.AlertTheReturnRequestListCouldNotBeObtained, 'The return request list could not be obtained'],
    [res.AletStoreListCouldNotBeObtained, 'Store list could not be obtained'],
    [res.ObtainingReturnReasons, 'Obtaining return reasons'],
    [res.AlertReturnReasonsCouldNotBeObtained, 'Return reasons could not be obtained'],
    [res.AlertStoreListCouldNotBeObtained, 'Store list could not be obtained'],
    [res.Approved, 'Approved'],
    [res.PendingRet, 'Pending'],
    [res.ReturnRequest, 'ReturnRequest'],
    [res.Approve, 'Approve'],
    [res.ReasonForReturn, 'Reason for return'],
    [res.Requested, 'Requested'],
    [res.Approval, 'Approval'],
    [res.ApprovedQuantity, 'Approved Quantity'],
    [res.Sent, 'Sent'],
    [res.AlertCouldNotGetTheRequestDetail, 'Could not get the request detail'],
    [res.SavingInformation, 'Saving information'],
    [res.ReturnsToSupplier, 'Returns to Supplier'],
    [res.StoreReturnReference, 'Store Return Reference'],
    [res.ObtainingReturnsToSupplier, 'Obtaining returns to supplier'],
    [res.AlertReturnsToSupplierCouldNotBeObtained, 'The list of returns to supplier could not be obtained'],
    [res.ShippingType, 'Shipping type'],
    [res.AmountSent, 'Amount Sent'],
    [res.AlertReturnDetailCouldNotBeObtained, 'The return detail could not be obtained'],
    [res.DownloadReport, 'Download Report'],
    [res.RequestTransfer, 'Request Transfer'],
    [res.DownloadLayout, 'Download Layout'],
    [res.DestinationStore, 'Destination store'],
    [res.TransferReference, 'Transfer reference'],
    [res.TransferStoreEntry, 'Invoice entry'],
    [res.EmployeeRecibedEntry, 'Employee who received'],
    [res.EmployeeConfirmedEntry, 'Confirming employee'],
    [res.ReceivedDate, 'Received date'],
    [res.ArticlesEntered, 'Articles entered'],
    [res.FolioTransferEntryTitle, 'Invoice entry'],
    [res.FoliosTransferEntryTitle, 'Invoice is entry'],
    [res.ObtainingTheCorporateTransfers, 'Obtaining the corporate transfers'],
    [res.AlertCorporateTransfersCouldNotBeObtained, 'Corporate transfers could not be obtained'],
    [res.GettingTheSectors, 'Getting the sectors'],
    [res.GettingTheWeeks, 'Getting weeks'],
    [res.AlertCouldNotGetTheSectors, 'Could not get the sectors'],
    [res.AlertYouMustFillTheFieldsOfTheForm, 'You must fill in all the fields of the form'],
    [res.SavingData, 'Saving data'],
    [res.DeletingTransfer, 'Deleting transfer'],
    [res.AlertHasBeenRemovedSuccessfully, 'Has been removed successfully'],
    [res.RequestNewTransfer, 'Request new transfer'],
    [res.Week, 'Week'],
    [res.Year, 'Year'],
    [res.Organization, 'Organization'],
    [res.OrganizationImgCollectorAdd, 'Organization to assign'],
    [res.UploadTransferFile, 'Upload transfer file'],
    [res.ContinueSaving, 'Continue saving'],
    [res.Transfer, 'Transfer'],
    [res.Origin, 'Origin'],
    [res.Destination, 'Destination'],
    [res.CorporateDateRequested, 'Corporate date requested'],
    [res.Season, 'Season'],
    [res.Rejected, 'Rejected'],
    [res.RejectedQuantity, 'Rejected Quantity'],
    [res.AlertTheTransfersCouldNotBeObtained, 'The transfers could not be obtained'],
    [res.AddStore, 'Add Store'],
    [res.Country, 'Country'],
    [res.CountryOperation, 'Operation Country'],
    [res.Active, 'Active'],
    [res.Inactive, 'Inactive'],
    [res.ParticipateQuantum, 'Participate Quantum'],
    [res.MigradaNEModal, 'Migrate New Schema'],
    [res.RequierePaqueteria, 'Require Package'],
    [res.ReasonForClosure, 'Reason for closure'],
    [res.ReopeningDate, 'Reopening date'],
    [res.Continue, 'Continue'],
    [res.ActivateStore, 'Activate store'],
    [res.StoreWillBeActivated, 'Store {0} will be activated. Do you want to continue?'],
    [res.DesactivateStore, 'Deactivate store'],
    [res.AreYouSureToDeactivateStore, 'Are you sure to deactivate store {0}?'],
    [res.ParticipationQuantumWillBeActivated, 'Participation in Quantum will be activated for store {0} Do you want to continue?'],
    [res.RemoveParticipateQuantum, 'Remove Participate Quantum'],
    [res.AreyouSureToDisableQuantumEngagement, 'Are you sure to disable Quantum engagement for store {0}?'],
    [res.AreyouSureToActivatedMigradaNE, 'Are you sure to Migrate New Schema engagement for store {0}?'],
    [res.AreyouSureToActivatedReqPaqueteria, 'Are you sure to activated Require Package engagement for store {0}?'],
    [res.AreyouSureToDisableMigradaNE, 'Are you sure to disable Migrate New Schema engagement for store {0}?'],
    [res.AreyouSureToDisableReqPaqueteria, 'Are you sure to disable Require Package engagement for store {0}?'],
    [res.AlertSelectClosingReason, 'Select closing reason'],
    [res.AlertSelectReopeningDate, 'Select reopening date'],
    [res.AlertStoreSuccessfullyUpdated, 'Store successfully updated'],
    [res.MasterData, 'Master data'],
    [res.BranchPlan, 'Branch plan'],
    [res.Attach, 'Attach'],
    [res.StoreNumberAbbr, 'Store Number'],
    [res.ActiveStore, 'Active Store'],
    [res.BrandType, 'Brand Type'],
    [res.Zone, 'Zone'],
    [res.Address, 'Address'],
    [res.ExteriorNumber, 'Exterior Number'],
    [res.InteriorNumber, 'Interior Number'],
    [res.Suburb, 'Suburb'],
    [res.City, 'City'],
    [res.State, 'State'],
    [res.PostalCode, 'Postal Code'],
    [res.Phone, 'Phone'],
    [res.Mail, 'Mail'],
    [res.LatitudeCoordinate, 'Latitude Coordinate'],
    [res.LengthCoordinate, 'Length Coordinate'],
    [res.SellingMeters, 'Selling Meters'],
    [res.TotalMeters, 'Total Meters'],
    [res.Capacity, 'Capacity'],
    [res.OpeningDate, 'Opening Date'],
    [res.CoordinatorRegion, 'Coordinator Region'],
    [res.SupervisorZone, 'Supervisor Zone'],
    [res.VIMZone, 'VIM Zone'],
    [res.ExecutiveZone, 'Executive Zone'],
    [res.Coordinator, 'Coordinator'],
    [res.Of, 'Of'],
    [res.To, 'To'],
    [res.ScheduledReopeningDate, 'Scheduled reopening date'],
    [res.StoreClosure, 'Store closure'],
    [res.ClosingDate, 'Closing date'],
    [res.Schedules, 'Schedules'],
    [res.ObtainingStoreData, 'Obtaining store data'],
    [res.GettingStoreHours, 'Getting store hours'],
    [res.ObtainingClosureReasons, 'Obtaining closure reasons'],
    [res.ObtainingListOfCountries, 'Obtaining list of countries'],
    [res.ObtainingListOfBrands, 'Obtaining list of brands'],
    [res.ObtainingListOfOrganizations, 'Obtaining list of organizations'],
    [res.GettingListOfStoreTypes, 'Getting list of store types'],
    [res.GettingListOfStoreLocations, 'Getting list of store locations'],
    [res.GettingListOfZones, 'Getting list of zones'],
    [res.EnterStoreNumber, 'Enter Store Number'],
    [res.ChangesHaveBeenSavedSuccessfully, 'Changes have been saved successfully'],
    [res.ErrorSavingTryAgain, 'Error saving. Try again.'],
    [res.OpeningHoursAreIncorrect, '{0} opening hours are incorrect'],
    [res.ClosingTimeIsIncorrect, '{0} closing time is incorrect'],
    [res.EnterStoreName, 'Enter store name'],
    [res.SelectCountry, 'Select country'],
    [res.SelectStoreType, 'Select Store Type'],
    [res.SelectStoreLocation, 'Select Store Location'],
    [res.SelectBrandType, 'Select Brand Type'],
    [res.SelectZone, 'Select Zone'],
    [res.LatitudeMustBeEqual, 'Latitude must be equal to or greater than -90 and less than or equal to 90'],
    [res.LengthMustBeEqual, 'Length must be equal to or greater than -180 and less than or equal to 180'],
    [res.SelectStoreClosingReason, 'Select store closing reason'],
    [res.SelectScheduledReopeningDate, 'Select scheduled reopening date'],
    [res.SelectClosingDate, 'Select closing date'],
    [res.BlueprintNotBeenUploaded, 'A blueprint not been uploaded for this store'],
    [res.Consignee, 'Consignee'],
    [res.CostCenter, 'Cost Center'],
    [res.HumanTalentExecutive, 'Human Talent Executive'],
    [res.Contract, 'Contract'],
    [res.ContractSignatureDate, 'Contract Signature Date'],
    [res.SquareMetersContract, 'Square Meters Contract'],
    [res.Expansion, 'Expansion'],
    [res.TotalSquareMeters, 'Total Square Meters'],
    [res.SquareMetersSaleFloor, 'Square Meters Sale Floor'],
    [res.SquareMetersMezzanine, 'Square Meters Mezzanine'],
    [res.SquareMetersWarehouse, 'Square Meters Warehouse'],
    [res.EnterValidNumberConsigneeField, 'Enter a valid number in the consignee field'],

    [res.ServiceUrl, 'Service URL'],
    [res.Devices, 'Devices'],
    [res.SerialCode, 'Serial Code'],
    [res.Identifier, 'Identifier'],
    [res.Model, 'Model'],
    [res.AssignedStore, 'Assigned Store'],
    [res.CurrentStore, 'Current Store'],
    [res.LastOnlineEvent, 'Last Online Event'],
    [res.APKVersion, 'APK Version'],
    [res.Unassigned, 'Unassigned'],
    [res.GettingStoreDevices, 'Getting store devices'],
    [res.ManageDevices, 'Manage Devices'],
    [res.Add, 'Add'],
    [res.DeviceType, 'Device Type'],
    [res.GettingDeviceList, 'Getting device list'],
    [res.AddDevice, 'Add Device'],
    [res.EditDevice, 'Edit Device'],
    [res.SelectARecordToEdit, 'Select a record to edit'],
    [res.DeviceRegisteredSuccessfully, 'Device registered successfully'],
    [res.DeviceEditedSuccessfully, 'Device edited successfully'],
    [res.FillInAllTheFieldsMarked, 'Fill in all the fields marked with'],
    [res.SelectStoreToWhichTheDeviceAssigned, 'Select store to which the device is assigned'],
    [res.StoreManagementByUser, 'Store management by user'],
    [res.Position, 'Position'],
    [res.TheOrganizationChartCouldNotBeDisplayed, 'The organization chart could not be displayed'],
    [res.DeletingUser, 'Deleting user'],
    [res.CouldNotDeleteThisUser, 'Could not delete this user'],
    [res.Validating, 'Validating'],
    [res.AllO, 'All'],
    [res.None, 'None'],
    [res.AddEmployee, 'Add employee'],
    [res.SaveEmployee, 'Save employee'],
    [res.EditEmployee, 'Edit employee'],
    [res.SaveChanges, 'Save changes'],
    [res.PositionsWereNotObtained, 'Positions were not obtained'],
    [res.CountriesWereNotObtained, 'Countries were not obtained'],
    [res.ThereWasAnErrorGettingTheStores, 'There was an error getting the stores'],
    [res.InvalidEmail, 'Invalid email'],
    [res.MissingAddEmail, 'Missing add email'],
    [res.SomeFieldsAreMissing, 'Some fields are missing. Please check'],
    [res.ThePlaceWasNotSaved, 'The place was not saved'],
    [res.ThePlaceWasNotUpdated, 'The place was not updated. Try again'],
    [res.EmployeeName, 'Employee name'],
    [res.CleanData, 'Clean Data'],
    [res.AllStores, 'All stores'],
    [res.Employees, 'Employees'],
    [res.RegisterEmployee, 'Register employee'],
    [res.EmployeeNumber, 'Employee Number'],
    [res.Email, 'Email'],
    [res.EmployeeDetail, 'Employee Detail'],
    [res.CouldNotGetTheZones, 'Could not get the zones'],
    [res.ItIsNotPossibleToDeleteAnAreaWithAssignedStores, 'It is not possible to delete an area with assigned stores. Please check and try again.'],
    [res.AreYouSureToDeleteTheZone, 'Are you sure to delete the zone?'],
    [res.GettingRegions, 'Getting regions'],
    [res.CouldNotGetTheRegions, 'Could not get the regions'],
    [res.InvalidZoneName, 'Invalid zone name'],
    [res.CantSave, 'Can not save'],
    [res.SelectRegion, 'Select region'],
    [res.ZoneCreatedSuccessfully, 'Zone created successfully'],
    [res.ZoneEditedSuccessfully, 'Zone edited successfully'],
    [res.ZoneDeletedSuccessfully, 'Zone deleted successfully'],
    [res.ManageZones, 'Manage Zones'],
    [res.AddZone, 'Add Zone'],
    [res.EditZone, 'Edit Zone'],
    [res.StoresAvailable, 'Stores available'],
    [res.DeleteZone, 'Delete Zone'],
    [res.Summary, 'Summary'],
    [res.TotalStocksTPV, 'Total Stocks TPV'],
    [res.TotalScannedQuantum, 'Total Scanned Quantum'],
    [res.TotalDifferences, 'Total Differences'],

    // Admin Modules
    [res.ManageModulesMenu, 'Manage Modules'],
    [res.ManageModulesTitle, 'Manage Modules'],
    [res.ManageModulesRowName, 'Name'],
    [res.ManageModulesRowStores, 'Stores with module disabled'],
    [res.ManageModulesSuccessMessage, 'Changes have been saved successfully.'],

    // InventoryDetail
    [res.TitleInventoryFilters, 'Inventory filters'],
    [res.TitleScannedProductSummary, 'Scanned product summary'],
    [res.TitleScansPerformedByProduct, 'Report of readings made during scanning'],
    [res.TitleDiferencesReportStyleVariety, 'Report differences by variety style'],
    [res.QuantumScanned, 'Scanned Quantum'],
    [res.StocksTPV, 'Stocks TPV'],

    // StoreReport
    [res.Checklist, 'Checklist'],


    // Activities Schedule
    [res.SelectStatus, 'Select a status'],
    [res.Consigment, 'Transfers in Transit'],
    [res.DateTransfer, 'Date of consigment'],
    [res.DateTransite, 'Days of transite'],
    [res.Red, 'Red'],
    [res.Yellow, 'Yellow'],
    [res.Green, 'Green'],
    [res.SelectStatus, 'Select a status'],
    // Admin Store
    [res.Society, 'Society'],
    [res.CcPayRoll, 'Cost Center (Payroll)'],
    [res.WareHouse, 'Warehouse'],
    [res.Sap, 'SAP'],
    [res.StoreCode, 'Store Code'],

    // InventoryCount Create/Detail
    [res.AlertOrganizationInfoCouldNotBeObtained, 'Could not get organization information'],
    [res.AlertConfigurationInfoCouldNotBeObtained, 'Could not get organization information with English language'],
    [res.GettingOrganization, 'Getting organization information'],
    [res.GettingEnglishOrganization, 'Obtaining organizations with English language'],
    [res.PrintingTags, 'Printing Tags'],
    [res.DeleteInventory, 'Delete Inventory'],
    [res.MessageDeleteInvetory, 'Do you want to write off the inventory '],

    // InventoryCount
    [res.InventoryDeletedSuccessfully, 'Inventory Deleted Successfully.'],

    [res.Import, 'Import'],
    [res.ImportFile, 'Import File'],
    [res.IncorrectLayout, 'Incorrect Layout'],
    [res.Restock, 'Restock'],
    [res.RestockChampions, 'Restock Champions'],
    [res.ReinforceCentralSizes, 'Reinforce Central Sizes'],
    [res.NewBasics, 'New Basics'],
    [res.RestockSave, 'Strategy saved successfully'],
    [res.RestockStatus, 'It is not possible to save the restock, check their status...'],
    [res.Stock, 'Stock'],
    [res.Sell, 'Sells'],
    [res.RestockReport, 'Restock Report'],
    [res.UnitsDetail, 'Units detail'],
    [res.CR, 'CR'],
    [res.NB, 'NB'],
    [res.RTC, 'RCS'],
    [res.Strategy, 'Strategy'],

    // Pre-ironed - InventoryCount
    [res.PreIroned, 'Pre-ironed'],
    [res.TheoreticalFile, 'Theoretical file'],
    [res.ChargeEntry, 'Charge entry'],
    [res.Sales, 'Sales'],
    [res.WareEntry, 'Merchandise entry'],
    [res.EndingTheoreticalInventory, 'Ending theoretical inventory'],
    [res.Concept, 'Concept'],
    [res.TitleInfo, 'Information'],
    [res.Total, 'Total'],
    [res.GenerateDetail, 'Generate detail'],
    [res.SKU, 'SKU'],
    [res.Completed, 'Completed'],
    [res.WithError, 'Not processed'],
    [res.WithoutProcess, 'Without processing'],
    [res.FileTypeNoSupported, 'Unsupported file type'],
    [res.Physical, 'Physical'],

    // Image Collector
    [res.ImageCollector, 'Image Collector'],
    [res.CreateImageCollector, 'New image'],
    [res.Module, 'Module'],
    [res.ModuleImgCollectorAdd, 'Module to assign'],
    [res.MSGInvalidFormat, 'Invalid Format'],
    [res.AlertOnlyImgfilesAreAccepted, 'OnlyImageFilesAreValid'],
    [res.AlertCouldNotSaveImageCollector, 'Could not save image'],
    [res.AlertCouldNotSaveImageCollectorLogIn, 'The selected organization must not exist for the selected module.'],
    [res.AlertCouldNotSaveImageCollectorCmbModuleNotSelected, 'You must select a module.'],
    [res.AlertCouldNotSaveImageCollectorCmbOrganizationNotSelected, 'You must select an organization.'],
    [res.AlertCouldNotSaveImageCollectorImgNotLoaded, 'You must load an image.'],
    [res.AlertCouldNotLoadImage, 'It was not possible to load image.'],
    [res.CreateImage, 'Create Image'],
    [res.Activate, 'Activate'],
    [res.ActivateImage, 'Activate image'],
    [res.ImageWillBeActivated, 'Do you want to activate the image?'],
    [res.SaveImageConfirmationAllOrganizations, 'Do you want to activate the image for module {0} in all organizations?.'],
    [res.SaveImageConfirmation, 'Do you want to activate the image for module {0} in organization {1}?.'],
    [res.SaveImage, 'Save Image'],
    [res.ImageCollectorUpdateSuccessfully, 'Image successfully activated.'],
    [res.ImageCollectorSaveSuccessfully, 'Image successfully saved.'],

    // Load Image
    [res.DragnDrop, 'Drag and drop file here'],
    [res.Or, 'or'],
    [res.BrowseForFile, 'Browse for file'],

    // Tenant
    [res.Tenant, 'Tenant'],
    [res.AlertThisUserDoesNotBelongATenantAvailable, 'This user does not belong to an available Tenant'],
    [res.AlertThereWasErrorConsultingTenant, 'There was an error consulting the Tenants'],
    [res.AlertTenantDataCouldNotBeObtained, 'Tenant information could not be obtained'],
    [res.TenantNotAvailable, 'Tenant Not Available'],
    [res.Tenant, 'Tenant'],
    [res.MigradaNE, 'Migrate N.S.'],
    [res.ReqPackage, 'Req. Package'],
    [res.CouldNotGetTenant, 'It was not possible to obtain the tenant'],

    // Organization
    [res.CouldNotGetOrganizations, 'It was not possible to obtain the organizations'],
    [res.AvailableOrganizations, 'Available organizations'],
    [res.OrganizationStores, 'Organization Stores'],

    // Admin Zones
    [res.Region, 'Region'],

    // Transfer Request
    [res.AlertTransfersCouldNotBeObtained, 'Transfers could not be obtained'],
    [res.ErrorTransferSector, '<div>The following records contain an invalid sector: </div>'],
    [res.ErrorTransferStoreNotOnlyMigrated, '<div>Containing migrated and non-migrated stores to new scheme of operation is not allowed.</div>'],
    [res.ErrorTransferStoreOrganization, '<div>The following stores do not belong to the selected organization: </div>'],
    [res.ErrorTransferStoreOriginDestiny, '<div>The following records contain the same store as origin and destination: </div>'],
    [res.ErrorTransferOrganization, '<div>The organization you select does not exist.</div>'],
    [res.ErrorTransferStyleOrganization, '<div>The following variety styles do not exist in the selected Organization:</div>'],
    [res.ErrorTransferStyleVariety, '<div>The following variety styles do not exist:</div>'],
    [res.ErrorTransferStyleSizeOrganization, '<div>The following style variety sizes do not exist in the selected Organization:</div>'],
    [res.ErrorTransferStyleSize, '<div>The following style variety sizes do not exist:</div>'],
    [res.ErrorTransferStyleQuantity, '<div>The following style variety sizes do not have a valid quantity::</div>'],
    [res.ErrorTransferStyleSizeMultiRow, '<div>The following records Source store -> Destination store -> Variety style -> Size have repeated records. <br>Do you want to save by grouping these lines?</br></div>'],
    [res.ErrorTransferTaskCreate, '<div>Transfer information saved successfully. Could not create transfer tasks.</div>'],
    [res.ErrorTransferCountToCreate, '<div>Could not get stored records when creating transfer.</div>'],
    [res.ErrorTransferWithDetCreate, '<div>It was not possible to determine if the records were stored correctly. Please check and/or try again.</div>'],
    [res.ErrorTransferDuplicateToday, '<div>A transfer with this code already exists. Please try again to create a version with suffix.</div>'],
    [res.ErrorTransferMaxVersionsReached, '<div>The maximum number of available versions has been reached for this code.</div>'],
    [res.ErrorTransferMaxVersionsPartial, 'The following codes have reached the version limit and cannot be created:'],
    [res.ErrorTransferMaxVersionsPartialConfirm, 'Do you want to continue creating only the codes that can be generated?'],
    [res.ErrorTransferNetworkRetry, '<div>Could not confirm whether the transfer was created. The process may still be running. Please wait a few minutes before trying again.</div>'],
    [res.ErrorTransferBatchPartial, '<div>Some transfers could not be created. The following origin → destination → sector pairs failed:</div>'],
    [res.Retry, 'Retry'],
    [res.TransferRequestCreatedSuccessfully, '<div>Transfer request created successfully.</div>'],
    [res.DuplicateWillCreateWithSuffix, 'Will be created with version suffix'],
    [res.DuplicateBlockedByMaxVersions, 'Cannot be created (version limit reached)'],
    [res.DuplicateExistingCode, 'Existing code'],
    [res.DuplicateWillBeCreatedAs, 'Will be created as'],
    [res.DuplicateConfirmMessage, 'Transfers with these codes already exist. Do you want to create additional versions with suffix?'],
    [res.DuplicateSummaryNewTransfers, '{0} transfers will be created normally (no conflict)'],
    [res.UnprocessedRecords, 'Unprocessed records'],
    [res.DeactivateRequests, 'Cancel Requests'],
    [res.DeactivateSuccess, 'Selected requests were deactivated successfully'],
    [res.DeactivateConfirm, 'Deactivate'],
    [res.DeactivateSuccessCount, 'deactivated'],
    [res.DeactivateFailedCount, 'not processed'],
    [res.DeactivateStoppedByLock, 'Stopped: lock window reached'],
    [res.DeactivateIrreversibleWarning, 'This action cannot be undone. Deactivated tasks cannot be reactivated.'],
    [res.DeactivateHoldToConfirm, 'Hold the button to confirm'],
    [res.DeactivateScheduledFor, 'Task scheduled for'],
    [res.Selected, 'selected'],
    [res.ValidatingStores, 'Validating stores'],
    [res.ValidatingStyles, 'Validating styles'],
    [res.ValidatingDuplicates, 'Checking duplicates'],
    [res.CreatingRequests, 'Creating requests'],
    [res.ConfirmLeaveWhileProcessing, 'A process is running. If you leave, only what has been processed so far will be saved. Are you sure you want to leave?'],

    // Transfer Store
    [res.ObtainingTransfersBetweenStores, 'Obtaining transfers between stores'],
    [res.ObtainingTransfersInTransit, 'Obtaining transfers in transit'],
    [res.PackageCollectionDate, 'Package Collection Date'],
    [res.EmployeeCollectionConfirm, 'Employee Collection Confirm'],
    [res.GuideCollection, 'Guide Collection'],
    [res.CommentCollection, 'Comment Collection'],


    //Label Design
    [res.LabelDesign, 'Label Design'],
    [res.PriceType, 'Price Type'],
    [res.LabelType, 'Type of label'],
    [res.LabelOriginaPrice, 'Reg Price'],
    [res.LabelSalePrice, 'Sale Price'],
    [res.AditionalRow, 'Aditional Row'],
    [res.PercentDiscount, 'Percent Discount'],
    [res.SelectLabelType, 'Select a label type'],
    [res.SelectBarcodeType, 'Select a barcode type'],
    [res.SelectAditionalRow, 'Select an option for the added row'],
    [res.PriceLabelSuccessfully, 'Label design saved successfully'],

    // Barcode examples
    [res.SkuExampleCode, '1020073003220'],
    [res.UPCExampleCode, 'X004538000076'],
    [res.EANExampleCode, '7500535167108'],

    // Default
    [res.ErrorUnknown, 'Unknown error'],
    [res.AllSelected, 'All selected'],
    [res.SmallerDateThan, 'The end date cannot be less than the start date.'],
    [res.GreaterDateThan, 'The start date cannot be greater than the end date.'],
    [res.RestockReport, 'Restock Report'],
    [res.SelectAStore, 'Select a store'],
    // Label Design
    [res.LabelDesign, 'Label Design'],
    [res.PriceType, 'Price Type'],
    [res.Empty, '(Empty)'],
    [res.FolioSAC, 'Folio SAC'],

    // PreIroned Inventory
    [res.Failures, 'Errors'],
    [res.ErrorMessageGenerateDetails, 'The detail has not been generated, you generated the detail and tried again.'],
    [res.FailureDate, 'Failure Date'],
    [res.FailureType, 'Failure Type'],
    [res.StoreCharge, 'Store Charge'],
    [res.FactoryCharge, 'Factory Charge'],
    [res.Regularization, 'Regularization'],
    [res.ThereAreErrorNoDownload, 'There are still errors, the file cannot be downloaded'],
    [res.NoFileCharged, 'There is no file loaded, it is not possible to proceed with the detail.'],

    //Dashboard WareEntry
    [res.WareEntryDetail, 'Ware entry detail'],
    [res.DownloadInvoice, 'Download invoice'],
    [res.AmountReceived, 'Amount received'],
    [res.AmountEntry, 'Amount entry'],
    [res.EnteredTo100, 'Entered at 100%'],
    [res.EnteredWithDiff, 'Entered with difference'],
    [res.PendingToEntry, 'Pending to entry'],
    [res.Percentage, 'Percentage'],
    [res.NumInvoices, 'Num invoices'],
    [res.BilledUnits, 'Billed units'],
    [res.UnitsEntered, 'Entered units'],

    //Returns
    [res.PiecesForReturn, 'Pieces authorized for return'],
    [res.SeeSettings, 'See settings'],
    [res.AlertEnterAnAmount, 'Enter an amount'],
    [res.NoticeReturnConfiuration, 'A configuration with the selected fields already exists for this store. Do you want to overwrite it?'],
    [res.AlertAmountMustGreaterThan0, 'Amount must be greater than 0'],
    [res.CorporateReturns, 'Corporate Returns'],
    [res.ReferenceRequestReturn, 'Reference Request Return'],
    [res.ReturnRequest, 'Request Return'],
    [res.UploadReturnFile, 'Upload return file'],
    [res.Division, 'Division'],
    [res.CedisPlant, 'Plant'],
    [res.EventLog, 'Event Log'],
    [res.MaximiumDateRequired, 'Max. Date Required'],
    [res.EmptyLayout, 'The loaded layout is empty'],
    [res.Cedis, 'Cedis'],

    //Invoicement
    [res.Invoicement, 'Invoicement'],
    [res.Invoices, 'Invoices'],
    [res.Requester, 'Requester'],
    [res.InvoicementDate,'Invoicement date'],
    [res.CreationDate, 'Creation date'],
    [res.BoxQuantity, 'Box quantity'],
    [res.DiffAmountSentEntry, 'Diff. Amount Env/Ing'],
    [res.DiffDaysReceivedEntry, 'Days Rec/Entry'],
    [res.DiffDaysSentReceived, 'Days Sent/Rec'],
    [res.Provider, 'Provider'],
    [res.GuideNumber, '# Guide'],
    [res.DetailShipmentGuides, 'Detail of shipping guides'],
    [res.Expiration, 'Expirated'],
    [res.PartialEntry, 'Entered Partial'],
    [res.CompleteEntry, 'Entered Complete'],
    [res.UnknownStatus, 'Unknown Status'],
    [res.Without_Reception, 'Entered Without Reception'],

    // Logger layouts
    [res.LoggerLayout, 'Logger Layout'],
    [res.LayoutCode, 'Layout Code'],
    [res.Username, 'Username'],
    [res.IncidenceWithLayout, 'Incidence with layout'],
    [res.IncidenceDate, 'Incidence date'],

    [res.Sector, 'Sector'],

    // Warning messages
    [res.warningMessage, 'Warning'],
    [res.AdviceSelectOptionStoreField, 'Select a valid option for the store field.'],
    [res.StatusTask, 'Task Status'],
    [res.NoOrganizationAssigned, 'No organization assigned'],

    // store report checklist
    [res.Executive, 'Executive'],
    [res.ScoreExt, 'Score Outside'],
    [res.ScoreInt, 'Score Inside'],
    [res.ScoreVar, 'Score Various'],
    [res.ActivityDate, 'Activity Date'],

    // Store Report Checklist Change Level
    [res.AlertCouldNotGetChangeLevelInstruction, 'Could not get the file. Verify that you have one assigned or try again.'],

    // Users Admin
    [res.UsersAdmin, 'Users Administration'],
    [res.Account, 'Account'],
    [res.ActiveDirectory, 'Active Directory'],
    [res.Domain, 'Domain'],
    [res.Password, 'Password'],
    [res.ApiUser, 'API User'],
    [res.CustomUser, 'Custom User'],
    [res.Confirmed, 'Confirmed'],
    [res.UserSavedSuccessfully, 'User saved successfully!'],
    [res.UserSaveFailed, 'User save Failed'],
    [res.AdminRoles, 'Roles Administration'],
    [res.Roles, 'Roles'],
    [res.RolesUpdatedSuccessfully, 'Roles updated successfully'],
    [res.RolesUpdateFailed, 'Roles update failed'],
    [res.AreYouSureDefault, 'Are you sure you want to perform this operation?'],
    [res.Permissions, 'Permissions'],
    [res.UserMustHaveOnlyOneRole, 'User must have only one role'],
    [res.UserAlreadyExists, 'User already exists'],
    [res.UserEditError, 'Error trying to edit user'],
    [res.ErrorGettingRoles, 'Error trying to get roles'],
    [res.ErrorSavingRoles, 'Error trying to save roles'],
    [res.ErrorGettingData, 'Error trying to get data'],
    [res.ErrorGettingPermissions, 'Error trying to get permissions'],
    [res.ErrorSavingPermissions, 'Error trying to save permissions'],
    [res.GeneratePassword, 'Generate random password'],

    // Unsold item Size
    [res.UnsoldItemSize, 'Artículos negados para venta'],

    [res.InventoryReport, 'Inventory Report'],

    [res.Canceled, 'Cancelado'],
    [res.Manifest, 'Manifest'],
    [res.ParcelGuide, 'Parcel Guide'],
    [res.Guide, 'Guide'],
    [res.ASNCodes, 'ASN Codes'],
    [res.ASNCode, 'ASN Code'],
    [res.CartonCode, 'Carton Code'],
    [res.DetailCartonGuide, 'Detail Carton / Guide'],
    [res.ManifestNumber, 'Manifest Number'],
    [res.EntryInventory, 'Entry Inventory'],
    [res.ShipmentASNDetail, 'ASN Merchandise Entry Detail'],
    [res.ReceptionDate, 'Recepction Date'],
    [res.StylesVarietyASN, 'ASN Styles Variety'],
    [res.sizeGroupDetCode, 'Size Code'],
    [res.styles, 'Styles'],
    [res.ExportFileNamePendingTransfers, 'pending_transfers'],
    [res.BulkMyUploads, 'My uploads'],
    [res.BulkUploadDetail, 'Upload detail'],
    [res.BulkUploadStartedNotice, 'The upload process has started. We will notify you when it finishes.'],
    [res.BulkJobFinishedNotice, 'Your transfer upload finished: {0} created, {1} not processed.'],
    [res.BulkSuccess, 'Processed'],
    [res.BulkFailed, 'Not processed'],
    [res.BulkDownloadFailed, 'Download not processed'],
    [res.BulkNoFailedRecords, 'There are no unprocessed records to download.'],
    [res.BulkLoadingDetail, 'Loading detail...'],
    [res.BulkStatusQueued, 'Queued'],
    [res.BulkStatusProcessing, 'Processing'],
    [res.BulkStatusDone, 'Completed'],
    [res.BulkStatusCompletedWithErrors, 'Completed with errors'],
    [res.BulkStatusFailed, 'Not processed'],
    [res.BulkStartedDate, 'Started'],
    [res.BulkFinishedDate, 'Finished'],
    [res.BulkRowCreated, 'Created'],
    [res.BulkRowFailed, 'Not processed'],
    [res.BulkRowSkipped, 'Skipped'],
    [res.Refresh, 'Refresh'],
    [res.ViewDetail, 'View detail'],
    [res.WhatsNewTitle, "What's New"],
    [res.WhatsNewLink, 'See this version news'],
    [res.WhatsNewAdded, 'New'],
    [res.WhatsNewImproved, 'Improved'],
    [res.WhatsNewFixed, 'Fixed'],
    [res.WhatsNewGotIt, 'Got it']
]);
